// Days an item has been in progress. Frozen once it lands in Done.
export function getDaysInProgress(item) {
  if (!item?.created_at) return null;
  const start = new Date(item.created_at);
  if (Number.isNaN(start.getTime())) return null;
  const isDone = item.status === 'done';
  const endSource = isDone && item.done_at ? new Date(item.done_at) : new Date();
  const end = Number.isNaN(endSource.getTime()) ? new Date() : endSource;
  const days = Math.floor((end.getTime() - start.getTime()) / 86400000);
  return { days: Math.max(0, days), frozen: isDone };
}

export function formatCurrency(value) {
  const n = Number(value || 0);
  return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function formatDate(value) {
  if (!value) return '—';
  const d = new Date(String(value).length <= 10 ? `${value}T00:00:00` : value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatShortDate(value) {
  if (!value) return '';
  const d = new Date(String(value).length <= 10 ? `${value}T00:00:00` : value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}
